import React from "react";

import {

    Wallet,

    Package,

    Star,

    MapPinned

} from "lucide-react";

import "./DashboardCards.css";

function DashboardCards({ dashboard }) {

    return (

        <div className="dashboard-cards">

            {/* Today's Earnings */}

            <div className="dashboard-card">

                <div className="card-icon earnings">

                    <Wallet size={26} />

                </div>

                <div>

                    <p>Today's Earnings</p>

                    <h2>

                        ₹

                        {

                            dashboard?.earnings?.today ?? 0

                        }

                    </h2>

                </div>

            </div>

            {/* Today's Orders */}

            <div className="dashboard-card">

                <div className="card-icon orders">

                    <Package size={26} />

                </div>

                <div>

                    <p>Today's Orders</p>

                    <h2>

                        {

                            dashboard?.statistics?.totalDeliveries ?? 0

                        }

                    </h2>

                </div>

            </div>

            {/* Rating */}

            <div className="dashboard-card">

                <div className="card-icon rating">

                    <Star size={26} />

                </div>

                <div>

                    <p>Rating</p>

                    <h2>

                        {

                            dashboard?.statistics?.rating ?? "5.0"

                        }

                    </h2>

                </div>

            </div>

            {/* Distance */}

            <div className="dashboard-card">

                <div className="card-icon distance">

                    <MapPinned size={26} />

                </div>

                <div>

                    <p>Distance</p>

                    <h2>

                        {

                            dashboard?.distance ?? 0

                        } km

                    </h2>

                </div>

            </div>

        </div>

    );

}

export default DashboardCards;